import { Directive, HostBinding } from '@angular/core';

/**
 * Sticky Menu Container Directive
 *
 * This directive is the container for sticky menu
 */
@Directive({
  selector: '[tdWbStickyMenuContainer]'

})
export class StickyMenuContainerDirective {
  /**
   * Host binding for sticky state
   */
  @HostBinding('class.td-wb-menu-sticky') containerClass: boolean = false;

  /**
   * This function toggles sticky state class based on flag.
   *
   * @param flag Boolean to toggle sticky state class
   */
  toggleClass(flag: boolean): void {
    this.containerClass = flag;
  }
}
